import { render, staticRenderFns } from "./ModuleHeader.vue?vue&type=template&id=45803530&scoped=true&"
import script from "./ModuleHeader.vue?vue&type=script&lang=js&"
export * from "./ModuleHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModuleHeader.vue?vue&type=style&index=0&id=45803530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45803530",
  null
  
)

export default component.exports